export default __webpack_public_path__ + "static/media/tight-shoulders.80f66717.png";